package com.partejar.app.core.ui.theme

import androidx.compose.runtime.Composable

@Composable
internal actual fun PartejarSystemBars(
    darkTheme: Boolean,
    lightStatusBarIcons: Boolean
) = Unit
